import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const ApellidosFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='APELLIDOS' htmlFor='select-apellidos' sm={2} alignRightAt='sm' />
      <Col sm={10}>
        <Field name='apellidos'>
          {({ field }) => (
            <Form.InputText
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-apellidos'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ApellidosFormGroup)
